import {
  SET_LIST,
  SET_DEPT,
  SET_TOTAL,
  SET_OFFSET,
  SET_MAX,
  SET_SORT,
  SET_ORDER,
  CLEAR,
} from "./mutation-types";

export default {
  [SET_LIST](state, listItems) {
    state["groupDeptMembers"] = [...listItems];
  },
  [SET_TOTAL](state, total) {
    state["total"] = total;
  },
  [SET_DEPT](state, dept) {
    state["dept"] = dept;
  },
  [SET_OFFSET](state, offset) {
    state["offset"] = offset;
  },
  [SET_MAX](state, max) {
    state["max"] = max;
  },
  [SET_SORT](state, sort) {
    state["sort"] = sort;
  },
  [SET_ORDER](state, order) {
    state["order"] = order;
  },
  [CLEAR](state) {
    state["groupDeptMembers"] = [];
    state["total"] = 0;
    state["max"] = 10;
    state["offset"] = 0;
    state["sort"] = "member.no";
    state["order"] = "ascending";
  },
};
